import React, { useCallback } from "react";
import { Badge, Button, Group, Loader } from "@mantine/core";

interface Props {
  state: "idle" | "pending" | "printing" | "success" | "failed";
  onRetry?: () => void;
}

export const PerItemPrintStateChip: React.FC<Props> = ({ state, onRetry }) => {
  const handleRetry = useCallback(() => {
    onRetry?.();
  }, [onRetry]);

  if (state === "idle") {
    return null;
  }

  if (state === "pending") {
    return <Badge color="gray">Queued</Badge>;
  }

  if (state === "printing") {
    return (
      <Group gap="xs">
        <Badge color="yellow">Printing…</Badge>
        <Loader size="xs" />
      </Group>
    );
  }

  if (state === "success") {
    return <Badge color="green">Printed</Badge>;
  }

  return (
    <Group gap="xs">
      <Badge color="red">Failed</Badge>
      <Button
        size="compact-xs"
        variant="light"
        color="red"
        onClick={handleRetry}
      >
        Retry
      </Button>
    </Group>
  );
};
